import React, { useEffect, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { ActionButtons, Subtitle, Title } from '../Utils/CustomClasses'
import styled from 'styled-components'
import './css/discountPopUp.css'
import { update } from 'lodash'

const ModalContainer = styled.div`
  background-color: white;
  border: 1px solid #d2d2d2;
  padding: 5px;
  width: auto;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 5px;
    flex-direction: column-reverse;
  }
`

const DiscountBox = styled.div`
  background-color: #ffffff;
  border: 2px dashed #154549;
  padding: 26px;
  text-align: center;
  width: 700px;

  @media (max-width: 768px) {
    padding: 20px 25px;
    width: 350px;
  }
`

const ContentWrapper = styled.div`
  flex-basis: 60%;
  margin-right: 20px;

  ul {
    list-style: none;
    padding-bottom: 23px;
  }

  @media (max-width: 768px) {
    margin-right: 0;
    margin-top: 20px;
  }

  @media (max-width: 950px) {
    flex-basis: 80%;
  }
`

const CloseLink = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  text-align: center;
  margin-top: 22px;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`

const PopTitle = styled.h2`
  font-family: 'Open Sans', sans-serif;
  font-size: 26px;
  color: #000000;
  margin: 22px 0 32px 0;
  font-weight: bolder;
  text-align: center;
  display: block;
`

const PopText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 190%;
  color: #000000;
  margin-bottom: 46px;

  span {
    color: rgb(234, 94, 85);
  }
`

const CopyButton = styled(ActionButtons)`
  color: #fff;
  padding: 10px 45px;
  background-color: ${(props) => props.bgColor || '#f19e38'};
  border-radius: 3px;
  font-weight: bolder;
  font-size: 24px;
  margin: 0 5px 5px 5px;
  text-decoration: none;
  width: 100%;

  &:hover {
    color: #ffffff;
    font-weight: 400;
    background-color: #bc4c44;
  }

  &:focus {
    color: #ffffff !important;
    font-weight: 400;
    background-color: ${(props) => props.bgColor || '#f19e38'};
    box-shadow: none;
  }

  @media (max-width: 768px) {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: bold;
    padding: 5px 25px;
  }
`

const CopyNotification = styled.div`
  color: #ea5e55;
  font-size: 16px;
  font-weight: bold;
  margin: -20px 0 20px 0;
  padding-left: 10px;
`

const MyFreebirdDiscountPopup = ({
  pageText,
  popTitle,
  popText,
  user,
  discountCode,
  clickedFeeLink,
  setShowPopup,
  showPopup,
  setIsCopied,
  iAminSubscriptionFormPanel,
  setIsCopiedInSubFormPanel,
}) => {
  const [popTextDisplay, setPopTextDisplay] = useState('')
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    console.log('===============================')
    console.log('===============================')
    console.log('===============================')
    console.log('showPopup: ' + showPopup)
    console.log('clickedFeeLink: ' + clickedFeeLink)
    console.log('user.status: ' + user.status)
    console.log('user.membershipFeeStatus: ' + user.membershipFeeStatus)

    if (
      showPopup &&
      clickedFeeLink &&
      user.status === 'registered' &&
      user.membershipFeeStatus !== 'completed'
    ) {
      console.log('>>>> true:')

      setShowPopup(true)
      setPopTextDisplay(
        popText.replace('{{*}}', '<span>' + discountCode + '</span>')
      ) // Set the dynamic text
    }
  }, [showPopup, clickedFeeLink, user, popText, discountCode])

  /*
    This controls the mouse movement
    we are checking as it goes outside above
  */

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (
        e.clientY < 50 &&
        clickedFeeLink &&
        user.status === 'registered' &&
        user.membershipFeeStatus !== 'completed'
      ) {
        setShowPopup(true)
      }
    }
    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [clickedFeeLink])

  const fadeStyles = useSpring({
    delay: 0,
    config: { duration: 200, config: 'gentle' },
    from: { opacity: 0, top: '80px' },
    to: {
      opacity: showPopup ? 1 : 0,
      top: showPopup ? '0' : '80px',
    },
  })

  const closePopup = (e) => {
    e.preventDefault()
    setShowPopup(false)
  }

  const copyCode = (e) => {
    e.preventDefault()
    navigator.clipboard
      .writeText(discountCode)
      .then(() => {
        setCopied(true)
        setIsCopied(true)
        setTimeout(() => {
          setCopied(false)
          setShowPopup(false)
        }, 1000)
      })
      .catch((err) => console.error('Failed to copy the code: ', err))
    console.log('in page?: ' + iAminSubscriptionFormPanel)
    if (iAminSubscriptionFormPanel === true) {
      setIsCopiedInSubFormPanel(true)
    }
  }

  return (
    <animated.div
      style={{
        display: 'flex',
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: 1000,
        justifyContent: 'center',
        pointerEvents: showPopup ? 'auto' : 'none',
        alignItems: 'center',
        overflow: 'hidden',
        ...fadeStyles,
      }}
      className={showPopup && 'is-clickable'}
    >
      <ModalContainer>
        <DiscountBox>
          <ContentWrapper>
            <PopTitle>{popTitle}</PopTitle>
            <PopText dangerouslySetInnerHTML={{ __html: popTextDisplay }} />
            {copied && <CopyNotification>{pageText[60]}</CopyNotification>}
            <CopyButton bgColor="#EA5E55" onClick={(e) => copyCode(e)}>
              {pageText[58]}
            </CopyButton>
            <CloseLink onClick={closePopup}>{pageText[59]}</CloseLink>
          </ContentWrapper>
        </DiscountBox>
      </ModalContainer>
    </animated.div>
  )
}

export default withRouter(withAuth(MyFreebirdDiscountPopup))
